var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"first-highlight-box"},[_c('p',[_vm._v(" Please review the highlighted sections. Click the edit icon to verify or update the information. ")]),_c('div',{staticClass:"d-flex justify-content-end"},[_c('b-button',{staticClass:"candash-addBtn-sm",on:{"click":function($event){return _vm.$emit('submit')}}},[_vm._v(" Okay ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }